export default "__VITE_ASSET__BPyipxyN__"